export const textShortener = (title: string, limit: number ) => {
    const shortTitle = title.split(' ').length > limit 
            ? `${title.split(' ').slice(0, limit).join(' ')}...` 
            : title.split(' ').slice(0, limit).join(' ');
  
    return shortTitle;
  }